import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  up_date: [
    {...makeRule('请选择发布时间段', 'string')},
  ],
  industry_type: [
    {...makeRule('请选择行业大类', 'integer')},
  ],
  position_type: [
    {...makeRule('请选择职业类型', 'integer')},
  ],
  title: [
    {...makeRule('请输入岗位名称', 'string')},
  ],
  employer_name: [
    {...makeRule('请输入发布单位', 'string')},
  ],
  hire_number: [
    {...makeRule('请输入招聘人数', 'integer')},
    {...makeRule('请输入大于0的整数', 'integer'), min: 1},
  ],
  address: [
    {...makeRule('请输入工作地点', 'string')},
  ],
  employer_id: [
    {...makeRule('请输入发布单位', 'string')},
  ],
  position_period: [
    {...makeRule('请选择工作时间', 'string')},
  ],
  working_shifts: [
    {...makeRule('请选择工作班次', 'string')},
  ],
  working_hours: [
    {...makeRule('请输入工作时长', 'number')},
  ],
  gender: [
    {...makeRule('请选择性别要求', 'integer')},
  ],
  certificate: [
    {...makeRule('请输入证件要求', 'string')},
  ],
  working_experience: [
    {...makeRule('请输入工作经验', 'string')},
  ],

  salary: [
    {...makeRule('请输入基本薪资', 'integer')},
  ],
  salary_type: [
    {...makeRule('请选择薪资方式', 'integer')},
  ],
  settlement_type: [
    {...makeRule('请输入结算方式', 'integer')},
  ],
  settlement_time: [
    {...makeRule('请选择结算时间', 'integer')},
  ],
  area_id: [
    {...makeRule('请选择区', 'integer')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/position/position.rules.js